import { CreatePasswordForm } from "@modules";

export const PageForgotPassword = () => {
  return <CreatePasswordForm />;
};
